import { render, staticRenderFns } from "./ProductSearchSelector.vue?vue&type=template&id=43f30423"
import script from "./ProductSearchSelector.vue?vue&type=script&lang=js"
export * from "./ProductSearchSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports